
import { Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ToolBoxDispolist_$reflection } from "../../Shared/Receiver.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { concat, printf, toText } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { State, Msg } from "./Types.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function getToolBoxDispolistCmd(userId, eventId) {
    return Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ToolBoxDispolist_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), toText(printf("/api/toolbox/%s/dispolist/%s"))(userId)(eventId), (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])));
}

export function initToolBoxDispolist(userId, eventId) {
    return [new State(undefined, userId), getToolBoxDispolistCmd(userId, eventId)];
}

export function update(msg, state) {
    let fullPath;
    switch (msg.tag) {
        case 1:
            return [new State(msg.fields[0], state.UserId), Cmd_none()];
        case 2:
            return [state, Cmd_none()];
        default:
            return [state, (fullPath = concat("/receivers/", ...state.UserId), Cmd_ofEffect((_arg) => {
                RouterModule_nav(singleton(fullPath), 1, 1);
            }))];
    }
}

